<app-my-ranking></app-my-ranking>
<table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="studentName">
        <th mat-header-cell *matHeaderCellDef>{{'account-management.leaderboard_student' | translate}}</th>
        <td mat-cell *matCellDef="let cell">{{ cell.studentName }}</td>
    </ng-container>

    <ng-container matColumnDef="points">
        <th mat-header-cell *matHeaderCellDef>{{'account-management.leaderboard_points' | translate}}</th>
        <td mat-cell *matCellDef="let cell">{{ cell.points }}</td>
    </ng-container>

    <ng-container matColumnDef="rank">
        <th mat-header-cell *matHeaderCellDef>{{'account-management.leaderboard_ranks' | translate}}</th>
        <td mat-cell *matCellDef="let cell">{{ cell.rank }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
